import { IconCheck, IconArrowRight } from './Icons';
import { mediaUrl } from './config';

/**
 * A promotional carousel slide.
 *
 * Banner records carry an admin-chosen `badgeColor`, which used to drive the
 * badge fill, the subtitle, the feature ticks and the discount label. That let
 * arbitrary hues (green "NEW ARRIVAL", violet "SUMMER SPECIAL") onto chrome the
 * app draws itself, which the four-colour brand system doesn't allow. Those
 * four elements are now brand-locked: promotional labels are orange, headings
 * and body copy are white over the navy overlay.
 *
 * The banner's own artwork is deliberately untouched -- `image` and the
 * `bgFrom`/`bgTo` gradient behind it are the creative, not interface, and the
 * brand restriction explicitly exempts promotional imagery. `badgeColor` is
 * still read for the slide's ambient `--glow`, where it only tints a blurred
 * halo behind the artwork rather than colouring any text or control.
 */
export default function BannerSlide({ banner, onClick, className = '' }) {
  return (
    <div
      className={`carousel-slide ${className}`.trim()}
      style={{ background: `linear-gradient(135deg, ${banner.bgFrom} 0%, ${banner.bgTo} 100%)`, '--glow': banner.badgeColor }}
      onClick={onClick}
    >
      {banner.image && (
        <img src={mediaUrl(banner.image)} alt={banner.title} className="slide-bg-img" draggable={false} />
      )}
      <div className="slide-overlay" />
      <div className="slide-inner">
        <div className="slide-content">
          {banner.badge && (
            <span className="slide-badge">
              {banner.badge}
            </span>
          )}
          <h2 className="slide-title">{banner.title}</h2>
          {banner.subtitle && <p className="slide-subtitle">{banner.subtitle}</p>}
          {banner.features?.filter(Boolean).length > 0 ? (
            <ul className="slide-features">
              {banner.features.filter(Boolean).map((feat, i) => (
                <li key={i} className="slide-feature-item">
                  <span className="slide-feature-icon"><IconCheck size={14} /></span>{feat}
                </li>
              ))}
            </ul>
          ) : banner.body && <p className="slide-body">{banner.body}</p>}
          {banner.ctaText && (
            <button
              type="button"
              className={`slide-cta ${banner.ctaStyle === 'dark' ? 'slide-cta-dark' : 'slide-cta-light'}`}
              onClick={e => { e.stopPropagation(); onClick?.(); }}
            >
              {banner.ctaText} <span className="slide-cta-arrow"><IconArrowRight size={14} /></span>
            </button>
          )}
        </div>
        {banner.discountBadge && (
          <span className="slide-discount-badge">{banner.discountBadge}</span>
        )}
      </div>
    </div>
  );
}
